import { render } from "./ClientReports.vue?vue&type=template&id=07b6980e&scoped=true"
import script from "./ClientReports.vue?vue&type=script&lang=js"
export * from "./ClientReports.vue?vue&type=script&lang=js"

import "./ClientReports.vue?vue&type=style&index=0&id=07b6980e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b6980e"]])

export default __exports__